import { Navigate, useLocation } from "react-router-dom";

export default function EmploymentRedirect() {
  const location = useLocation();
  // Redirect from /people/:pgaId/person/employment to /people/:pgaId/career/employment
  const newPath = location.pathname.replace("/person/employment", "/career/employment");
  return <Navigate to={`${newPath}${location.search}`} replace />;
}
